export enum EmptyPayformSaveTypes {
  SaveReturnNoSchedule = 'saveReturnNoSchedule',
  ApproveNoSchedule = 'approveNoSchedule',
  ApproveNoSchdOrPdActvty = 'approveNoSchdOrPdActvty',
}
